// extracted by mini-css-extract-plugin
export default {"changeStyleButton":"ChangeStyle_changeStyleButton__6Tdhs","buttonContainer":"ChangeStyle_buttonContainer__uPP64"};